<div class="litmus-label-container">
    <div class="litmus-labels" *ngFor="let label of labels;">
        <div class="litmus-label-header">{{label.header}}</div>
        <div class="litmus-label-value">{{label.value}}</div>
    </div>
</div>